import { call } from 'redux-saga/effects'
import getUrlParam from 'helpers/getUrlParam'
import axios from 'api/config'
import handlePermalink from 'sagas/setupProjectsSaga/handlePermalink'
import getModelFromPath from 'sagas/setupProjectsSaga/getModelFromPath'
import getManufacturerFromPath from 'sagas/setupProjectsSaga/getManufacturerFromPath'

export default function * retrieveDataFromUrl() {
  const model = yield call(getModelFromPath, getUrlParam('model_path'))
  const manufacturer = yield call(getManufacturerFromPath, window.location.pathname)

  // get permalink project
  const permalinkProject = getUrlParam('permalink')
  ? yield axios
      .get(`/calculator_permalinks/${getUrlParam('permalink')}.json`)
      .then(yield handlePermalink)
      .catch(_ => null)
  : null

  return { model, permalinkProject, manufacturer }
}



// WEBPACK FOOTER //
// ./src/sagas/setupProjectsSaga/retrieveDataFromUrl.js